module.exports = __webpack_public_path__ + "img/icon_box_1_2.4baae6f0.png";